// @flow

export const RECEIVED_NEWS: 'listo/news/RECEIVED_NEWS' = 'listo/news/RECEIVED_NEWS';
export const ADD_NEWS: 'listo/news/ADD_NEWS' = 'listo/news/ADD_NEWS';
export const UPDATE_LINK: 'listo/news/UPDATE_LINK' = 'listo/news/UPDATE_LINK';

export default null;
